import { DebtorMergeHistory } from "us.collection.debtor/Interfaces";

/**
 * @function
 * @description - Set name and adress for table data
 * @param {Array<DebtorMergeHistory>} debtorList - Debtor list
 * @returns
 */
const setTableProperties = (debtorList: Array<DebtorMergeHistory>): Array<DebtorMergeHistory> => {
  try {
    const debtors = debtorList?.map((debtor: DebtorMergeHistory) => {
      return {
        ...debtor,
        key: `${debtor.entRoleId}-${debtor.mergeDate}`,
        name: `${debtor?.firstName} ${debtor?.lastName}`,
        address: [debtor?.address1, debtor?.address2, debtor?.address3]
                .filter((part) => part) 
                .join(', ')
      };
    });
    return debtors;
  } catch {
    return [];
  }
};

/**
 * @function
 * @description - Set children prop for table tree
 * @param {Array<DebtorMergeHistory>} debtorList - Debtor list
 * @returns - Modified debtor list
 */
export const getChildDebtorHistory = (debtorList: Array<DebtorMergeHistory>) => {
  try {
    const destinationDebtor = setTableProperties(debtorList).filter(
      (debtor: any) => debtor?.isDestinationDebtor
    );
    return [
      {
        ...destinationDebtor[0],
        children: setTableProperties(debtorList)?.filter(
          (debtor: any) => !debtor?.isDestinationDebtor
        ),
      },
    ];
  } catch {
    return [];
  }
};
